import { render, staticRenderFns } from "./RequisitionSummary.vue?vue&type=template&id=13558e6c"
import script from "./RequisitionSummary.vue?vue&type=script&lang=js"
export * from "./RequisitionSummary.vue?vue&type=script&lang=js"
import style0 from "./RequisitionSummary.vue?vue&type=style&index=0&id=13558e6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports